import { notification, Space } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { io } from "socket.io-client";
import { WEBSOCKET_URL } from "../config";
import { SOCKET_EMITS } from "../common/constants";
import { addRideRequest } from "../actions/ride";

function WebSocket() {
  const isUserLoggedin = useSelector((state) => state.token.tokenData);
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch();

  const socketInitializer = (socket) => {
    socket.on("connect", (data) => {
      //connected
    });

    socket.on(SOCKET_EMITS.new_barc_ride, (data) => {
      dispatch(addRideRequest(data.content));
      api.info({
        message: `New Ride Request(${data.content.id})`,
        description: "There is a new ride request added to the list.",
        placement: "top",
        duration: 10,
      });
    });
  };

  useEffect(() => {
    const socket = io(WEBSOCKET_URL, {
      auth: { token: isUserLoggedin?.access_token },
      path: "/socket/",
    });
    if (isUserLoggedin) {
      socketInitializer(socket);
    }
  }, [isUserLoggedin]);

  return <Space>{contextHolder}</Space>;
}

export default WebSocket;
